import { render, staticRenderFns } from "./Messenger.vue?vue&type=template&id=600f3aae&scoped=true"
import script from "./Messenger.vue?vue&type=script&lang=js"
export * from "./Messenger.vue?vue&type=script&lang=js"
import style0 from "./Messenger.vue?vue&type=style&index=0&id=600f3aae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600f3aae",
  null
  
)

export default component.exports